import { render, staticRenderFns } from "./RefreshItem.vue?vue&type=template&id=ebaed466&scoped=true&"
import script from "./RefreshItem.vue?vue&type=script&lang=js&"
export * from "./RefreshItem.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=ebaed466&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebaed466",
  null
  
)

export default component.exports